import React from 'react';
import { Box, Paper } from '@material-ui/core';
import CardTheme from './Card.styles';

const Card = (props) => {
  const classes = CardTheme();
  const table = props.options.tabela || [];
  const borderLeft = `5px solid ${props.options.cor}`;
  const cursor = table.length > 0 ? 'pointer' : 'initial';
  
  const showTable = () => {
    if (table.length > 0) {
      props.options.setTabelaAtual(table);
      props.options.abrirModal();
      props.options.setNomeTabela(props.options.texto);
    }
  }

  return (
    <Paper className={classes.root}>
      <Box className={classes.boxContainer} style={{ cursor: cursor, borderLeft: borderLeft }} onClick={() => showTable()}>
        <Box className={classes.boxDados}>
          <p className={classes.textoDescricao}>{props.options.texto}</p>
          <p className={classes.textoQuantidade}>{props.options.value}</p>
        </Box>
      </Box>
    </Paper>
  )
};

export default Card;
